<template>
  <table-paginator :data="orders" @pagechange="$emit('pagechange', $event)">
    <hr class="mb-0" />

    <template v-for="row in orders.data">
      <b-row
        align-v="center"
        class="grid-table-row mx-0 px-0"
        :key="row.id"
        @click="handleRowClick(row)"
      >
        <div class="col-4 col-md-1 align-middle text-center text-primary pl-0">
          <small>{{ row.saved_at | dateTimeBr }}</small>
        </div>

        <template v-if="row.unidentified_client == 0">
          <div class="col-8 col-md-4 mb-3 mb-md-0 d-flex">
            <avatar
              inline
              color="#fff"
              :size="30"
              :username="row.name"
              :initials="row.name.slice(0, 1)"
            ></avatar>

            <span style="margin-left: 10px"
              >{{ row.name }}
              <a
                class="btn btn-link text-success"
                @click.stop
                v-if="row.phone_wa != null"
                :href="getWhatsAppLink(row)"
                target="_blank"
                ><i class="fab fa-lg fa-whatsapp"></i
              ></a>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="col-8 order-1 col-md-4 order-md-2 mb-3 mb-md-0">
            <avatar
              inline
              color="#fff"
              :size="30"
              :username="'Consumidor Final'"
              :initials="'CF'"
            ></avatar>
            <span style="margin-left: 10px">Venda à vista</span>
          </div>
        </template>

        <div
          class="
            col-3
            order-3
            col-md-2
            order-md-4
            align-middle
            text-center text-primary
          "
        >
          <span v-if="row.salesman" style="margin-left: 10px">{{
            row.salesman.name
          }}</span>
          <span v-if="!row.salesman" style="margin-left: 10px">-</span>
        </div>
        <div class="col-md-1 order-md-4 align-right text-center text-primary">
          <!-- <div
            v-b-popover.hover="popoverConfig(row.order_bill)"
            title="Pagamentos"
          <i class="fas fa-coins mr-2"></i>
          > -->
          <b>{{ row.net_total | decimal }}</b>
          <!-- </div> -->
        </div>
        <div
          class="
            col-3 col-md-1
            order-md-4
            align-middle
            text-center text-primary
          "
        ></div>
        <div
          class="
            col-8
            order-5
            col-md-2
            order-md-5
            align-middle
            text-md-center text-right
          "
        >
          <template v-if="row.nfe">
            <template v-for="(nfe, index) in row.nfe">
              <i
                :class="[
                  'fas fa-sm fa-file-invoice',
                  nfeIconStatus(nfe.status),
                ]"
                style="margin-right: 10px"
                v-if="hasNfe(row)"
                :key="index"
                :title="
                  'NF número: ' +
                  nfe.nNF +
                  ' (' +
                  getNfeStatus(nfe.status) +
                  ')'
                "
              ></i>
            </template>
          </template>
          <i
            class="fas fa-dollar-sign text-success"
            style="margin-rigth: 5px"
          ></i>
          <i
            class="fas fa-sm fa-check text-primary"
            style="margin-rigth: 5px"
            v-if="row.finance_status == 1"
          ></i>
          <i
            class="fas fa-sm fa-times text-danger"
            style="margin-rigth: 5px"
            v-if="row.finance_status == 0"
          ></i
          >&nbsp;&nbsp;

          <i class="fas fa-cubes text-success" style="margin-rigth: 5px"></i>
          <i
            class="fas fa-sm fa-check text-primary"
            style="margin-rigth: 5px"
            v-if="row.stock_status == 1"
          ></i>
          <i
            class="fas fa-sm fa-times text-danger"
            style="margin-rigth: 5px"
            v-if="row.stock_status == 0"
          ></i
          >&nbsp;&nbsp;

          <order-status-badge :order="row" />
        </div>
        <div class="col-12 order-6 col-md-1 order-md-6 align-rigth text-center">
          <b-dropdown
            variant="light"
            dropleft
            :boundary="'window'"
            toggle-class="text-decoration-none"
            no-caret
            v-if="row.status !== 'c'"
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v text-muted" />
            </template>
            <b-dropdown-item
              v-if="row.finance_status == 1 && row.status == 'o'"
              @click.stop="$emit('PrintOrder', row)"
            >
              <i class="fas fa-print" />
              Imprimir Venda
            </b-dropdown-item>
            <b-dropdown-item
              v-if="row.status == 'p'"
              @click.stop="$emit('PrintOrder', row)"
            >
              <i class="fas fa-print" />
              Imprimir Orçamento
            </b-dropdown-item>
            <b-dropdown-item @click.stop="printOrder(row)" disabled>
              <i class="fas fa-print" />
              Imprimir Rascunho
            </b-dropdown-item>

            <template v-if="canEmitNfe(row)">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                @click.stop="
                  $emit('emitNfe', {
                    id: row.id,
                    value_nf: row.net_total,
                    model: 55,
                  })
                "
              >
                <i class="fas fa-file-invoice" />
                Emitir NF-e
              </b-dropdown-item>
              <b-dropdown-item
                @click.stop="
                  $emit('emitNfe', {
                    id: row.id,
                    value_nf: row.net_total,
                    model: 65,
                  })
                "
              >
                <i class="fas fa-receipt" />
                Emitir NFc-e
              </b-dropdown-item>
            </template>

            <template
              v-if="
                row.finance_status !== 1 && row.status == 'o' && orderCreateEdit
              "
            >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click.stop="$emit('EmitOrderBill', row.id)">
                <i class="fas fa-cash-register" />
                Lançar Contas
              </b-dropdown-item>
            </template>

            <template
              v-if="
                row.status == 'o' &&
                enabledStock &&
                row.stock_status == 0 &&
                orderCreateEdit
              "
            >
              <b-dropdown-item @click.stop="$emit('emitMovimentStock', row.id)">
                <i class="fas fa-box" />
                Lançar Estoque
              </b-dropdown-item>
            </template>

            <template
              v-if="
                row.status == 'o' && row.operation_id == 1 && orderCreateEdit
              "
            >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click.stop="handleCreateReturningFrom(row.id)">
                <i class="fas fa-undo-alt" />
                Devolver produtos
              </b-dropdown-item>
            </template>

            <template v-if="row.status !== 'c' && orderCancel">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click.stop="$emit('CancelOrder', row)">
                <i class="fas fa-ban text-danger" />
                Cancelar
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </b-row>
      <hr class="my-0" />
    </template>
    <order-view ref="orderView" />
  </table-paginator>
</template>
<script>
import PrRow from "../printers/grid/PrRow";
import TablePaginator from "./../sections/TablePaginator.vue";
import Avatar from "vue-avatar";
import OrderStatusBadge from "@/components/sections/order/OrderStatusBadge";
import OrderView from "../order/forms/OrderView";

export default {
  components: {
    PrRow,
    TablePaginator,
    Avatar,
    OrderStatusBadge,
    OrderView,
  },

  props: {
    orders: {},
  },

  data: () => ({
    tableColumns: [
      { key: "saved_at", label: "Data" },
      { key: "client", label: "Cliente" },
      { key: "salesman", label: "Vendedor" },
      { key: "net_total", label: "Valor" },
      //{ key: "order_bill", label: "Pagamentos" },
      { key: "nfe", label: "Status" },
      { key: "actions", label: "Ações " },
    ],
    operations: {
      1: {
        path: "venda",
      },

      2: {
        path: "devolucao",
      },
    },

    payment_method: {
      1: {
        text: "Dinheiro",
        class: "badge-primary",
      },

      2: {
        text: "Cheque",
        class: "badge-primary",
      },

      3: {
        text: "Cartão de Credito",
        class: "badge-secondary",
      },
      4: {
        text: "Cartão de Débito",
        class: "badge-secondary",
      },
      5: {
        text: "Crediário",
        class: "badge-secondary",
      },

      15: {
        text: "Boleto Bancário",
        class: "badge-secondary",
      },

      16: {
        text:"Depósito Bancário",
        class:"badge-secondary"
      },

      17: {
        text: "PIX",
        class: "badge-secondary",
      },
      18: {
        text: "Carteira Digital ",
        class: "badge-secondary",
      },
      99: {
        text: "Outros",
        class: "badge-secondary",
      },
    },

    nfeStatuses: {
      n: "Não enviada",
      p: "Processando",
      r: "Denegada",
      a: "Autorizada",
      i: "Inutilizada",
      c: "Cancelada",
    },
  }),

  computed: {
    enabledStock() {
      if (this.$store.state.company.module_stock_active == 1) {
        return true;
      }
    },

    hasModuleNfe() {
      if (!this.$store.state.user) {
        return false;
      }

      if (this.$store.state.user.master_user_id != 3) {
        return false;
      }

      return true;
    },

    orderCancel() {
      return this.$acl.can("orderCancel");
    },
    orderCreateEdit() {
      return this.$acl.can("orderCreateEdit");
    },
  },

  methods: {
    // popoverConfig(bill) {
    //   let orderBill = {};
    //   let values = {};

    //   orderBill = bill.map((index) => {
    //     return this.payment_method[index.payment_method].text;
    //   });

    //   values = bill.map((index) => {
    //     return index.value;
    //   });

    //   return {
    //     html: true,
    //     title: () => {
    //       return "<b>Pagamentos:</b> ";
    //     },
    //     content: () => {
    //       return "parcelas:<br><em>" + orderBill + "</em>";
    //     },
    //   };
    // },

    canEmitNfe(row) {
      return row.operation_id == 1;
    },

    handleRowClick(row) {
      if (row.status == "d" || row.status == "p") {
        this.editOrder(row);
      } else {
        this.$refs.orderView.open(row.id);
      }
    },

    editOrder(row) {
      this.$router.push(
        "/vendas/" +
          this.operations[row.operation_id].path +
          "/editar/" +
          row.id
      );
    },

    handleCreateReturningFrom(id) {
      this.$router.push("/vendas/devolucao/novo?fromOrder=" + id);
    },

    getWhatsAppLink(orders) {
      let name = orders.name.replace(/ .*/, "");
      let link = "https://api.whatsapp.com/send?phone=+55" + orders.phone_wa;
      let msg =
        "&text=Olá " + name + ", Gostariamos de agradecer por comprar conosco!";

      return link + msg;
    },

    hasNfe(row) {
      return row.nfe.length > 0;
    },

    nfeIconStatus(status) {
      return status == "a" ? "text-success" : "text-secondary";
    },

    getNfeStatus(status) {
      return this.nfeStatuses[status];
    },
  },
};
</script>

<style>
</style>
